import { render } from "./AxcessFrame.vue?vue&type=template&id=602345da&scoped=true"
import script from "./AxcessFrame.vue?vue&type=script&lang=js"
export * from "./AxcessFrame.vue?vue&type=script&lang=js"

import "./AxcessFrame.vue?vue&type=style&index=0&id=602345da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602345da"]])

export default __exports__